<div [ngClass]="noBanner ? 'no-banner' : ''">
    @if (contentError?.Code > 0) {
    <dottnet-content-view [targetBanner]="targetBanner()" [topic]="topic()" [userDTO]="userDTO()" [template]="template()" [livreaActiveFlag]="livreaActiveFlag()" [billboardDetail]="billboardDetail" [squareDetail]="squareDetail">
        <dottnet-message-in-page detail [title_message]="title_message" [message]="getErrorMessage(contentError)" class="flex-fill"></dottnet-message-in-page>
        <dottnet-content-visualizer side [contents]="articleLatestNews()" [visualizationType]="FileVisualizationType.ListCardDxColumn" class="flex-fill" [applyDeferring]="true">
        </dottnet-content-visualizer>
    </dottnet-content-view>
    } @if (!contentError?.Code) {
    <dottnet-content-view [noBanner]="noBanner" [targetBanner]="targetBanner()" [topic]="topic()" [userDTO]="userDTO()" [template]="template()" [livreaActiveFlag]="livreaActiveFlag()" [billboardDetail]="billboardDetail" [squareDetail]="squareDetail">
        @if (currentContent(); as file) {
        <div detail class="file-wrapper">
            <h1 class="dottnet-title">{{ file.titolo }}</h1>
            <div class="header header-margin">
                <a href="{{ file.descrizioneTopic }}">{{ file.descrizioneTopic }}</a> {{ file.autore }} | {{ file.dataCreazione | date : 'dd/MM/yyyy HH:mm' : 'UTC' }}
            </div>
            @if (userId>0) {
            <div class="flex-row flex-justify-center">
                <dottnet-polls [poll]="pollSignal()" (submitPollEmitter)="submitPoll($event)" (undoPollEmitter)="undoPoll()" />
            </div>
            }
            <dottnet-pdf-viewer class="fullsize-file-viewer" [download]="file.download" [scrollable]="file.scrollable" [title]="file.titolo" [contentSrc]="file.url" [urlWithContext]="file.permalink"></dottnet-pdf-viewer>
        </div>
        }
        <dottnet-social detail [url]="shareLink"></dottnet-social>
        <dottnet-content-visualizer side [contents]="articleLatestNews()" [visualizationType]="FileVisualizationType.ListCardDxColumn" class="flex-fill" [applyDeferring]="true">
        </dottnet-content-visualizer>
    </dottnet-content-view>
    }
</div>
